import script from "./MonitoringCamera.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitoringCamera.vue?vue&type=script&setup=true&lang=js"

import "./MonitoringCamera.vue?vue&type=style&index=0&id=620624a3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-620624a3"]])

export default __exports__